<template>
  <div id="GeneralInfo">
    <div class="page-header bg-brand-secondary" >
      <div class="content-container row">
        <div class="page-title col-12">
          <h2>General Info</h2>
        </div>
      </div>
    </div>
    <div class="bg-white px-md-5">
      <div class="content-container row py-5" v-if="orgPages.length > 0">
        <div class="col-12 col-lg-5 my-5 pr-0 pr-lg-5" v-if="screenWidth > 992 || !pageSelected">
          <div class="page-results-wrap">
            <div
                    v-for="(page, i) in orgPages"
                    :key="i"
                    :class="{ active: i == activeItem }"
                    class="page-event brand-secondary border-brand-primary row mb-3"
                    @click="viewPage( i)"
            >
              <div class="icon px-4">
                <img :src="getIcon(page.category_id)">
              </div>
              <span class="page-title pl-5">
                {{ page.title }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 d-block d-lg-none" v-if="pageSelected">
          <a @click="viewMenu"
             class="return-link brand-secondary"
          ><i class="fas fa-chevron-left"></i>Back to pages</a>
        </div>
        <div class="col-12 col-lg-7 my-5" v-if="screenWidth > 992 || pageSelected">
          <div class="page-head bg-brand-secondary"></div>
          <div class="page-content" v-if="orgPages[activeItem]">
            <div class="page-title mx-5">
              <div class="title-box">
                <h3>{{orgPages[activeItem].title}}</h3>
              </div>
            </div>
            <div class="page-description">
              <h4>{{orgPages[activeItem].content.content_description}}</h4>
            </div>
            <div class="page-text" v-html="decodeURIComponent(orgPages[activeItem].content.content)"></div>
          </div>
        </div>
      </div>
      <div class="content-container no-content row" v-else>
        <div class="col-12">
          <img class="pb-5" src="/img/my-company/placeholder.svg" />
          <h4>Your organisation doesn't have anything to show here at the moment!</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "GeneralInfo",
  components: {},
  data() {
    return {
        orgPages: [
            {
                category_id: 9,
                title: 'Manager Support',
                content:{
                    content_description: 'Manager Support through the EAP',
                    content:"<p>The EAP service is well equipped to support managers, supervisors and team leaders, who may require the service themselves or whose role involves managing employees and employee issues.</p>" +
                    "<p>In addition to helping managers understand the EAP and how to recommend it to their staff when appropriate, we can support and advise management in the day to day issues they may face in their role, such as coping with change and stress in the workplace, implementing changes within a team or having difficult conversations with employees.</p>" +
                    "<p>Here are some examples of why a manager may contact the service:</p>"+
                        "<ul><li>For advice on their own personal emotional wellbeing</li>" +
                        "<li>When under stress from the manager role, a manager may feel under pressure with their workload and could seek advice and help around strategies for preventing overload and burnout for themselves and their team</li>"+
                        "<li>When dealing with employee performance issues, a manager may want direction on how to handle a difficult performance discussion with an employee, which they may feel uncomfortable or nervous about</li>"+
                        "<li>When breaking bad news to employees or conducting emotional or difficult interviews with team members, a manager may want to consult on strategies for handling a situation tactfully and without conflict</li>"+
                        "<li>When helping employees with personal issues at home</li>"+
                        "<li>When a manager has concerns over the well-being of an employee, a manager could seek information on how to identify a drug or alcohol problem or mental health issue within their team and advice on how to approach the individual with sensitivity.</li>"+
                        "<li>When looking for guidance on how to help staff members react and support a colleague who has experienced a mental health issue or personal tragedy</li>"+
                        "<li>When managing change or conflict within a team.</li>"+
                    "</ul>"


                }
            },
            {
                category_id: 9,
                title: 'Management Referrals',
                content:{
                    content_description: null,
                    content: "<p>As well as helping managers deal with the unique issues they face, the EAP can provide help to any manager who is concerned about a member of their team and may wish to refer them on to the EAP service.</p>" +
                    "<p> With the employees express permission we can accept management referrals and will support individual managers around individual cases.</p>" +
                    "<p> After an individual has completed the treatment they were referred for, with their signed consent, we will send a summary via secure email to the referring individual or client HR representative to inform them of the outcome.</p>"+
                    "<h4 class='text-center'>How to refer one of your team to the EAP</h4>"+
                    "<ul><li>Complete the Manager Referral Form available <a href='https://spectrum-life-media.s3.eu-west-1.amazonaws.com/CONTENT/EAP_Laya/Managment-Referral-Form+Laya+V9+012024.docx' target='_blank'>here</a></li>" +
                    "<li>Have the employee sign the form to confirm consent</li>"+
                    "<li>Email a copy of the Manager Referral Form to eap@spectrum.life</li>"+
                    "<li>Employee will be called within 24 hours</li>"+
                    "<li>This contact with the employee will be confirmed with the referring manager</li>"+
                    "<li>Any questions? Please call the EAP service on Ireland Freephone: 1800 903 542, UK Freephone: 0808 196 2016 or International: 00353 1 518 0277\n</li>"+
                    "</ul>"
                }
            },/*
            {
                category_id: 9,
                title: 'How to refer one of your team to the EAP',
                content:{
                    content_description: null,
                    content: "<ul><li>Complete the Manager Referral Form available <a href='/img/Management-Referral-Form.pdf' target='_blank'>here</a></li>" +
                    "<li>Have the employee sign the form to confirm consent</li>"+
                    "<li>Email a copy of the Manager Referral Form to eap@spectrum.life</li>"+
                    "<li>Employee will be called within 24 hours</li>"+
                    "<li>This contact with the employee will be confirmed with the referring manager</li>"+
                    "<li>Any questions? Please call the EAP service on Ireland Freephone: 1800 903 542, UK Freephone: 0808 196 2016 or International: 00353 1 518 0277\n</li>"+
                    "</ul>"
                }
            }, */
        ],
        icons:[
            { id: 9, path:'icon_general-grey.svg'},
            { id: 1, path:'icon_fitness-grey.svg'},
            { id: 2, path:'icon_nutrition-grey.svg'},
            { id: 8, path:'icon_wellbeing-grey.svg'},
        ],
        activeItem: 0,
        pageSelected: false,
        screenWidth: 0,
    };
  },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
  mounted() {
  },
  methods: {

      getIcon(icon){
          var matched = null;
          var output = '';

          this.icons.map(function (i) {
              if (i.id === icon ) {
                  output =  i.path;
                  matched = true;
              }
          });

          if (!matched){
              output = this.icons[0].path;
          }
          return '/img/my-company/' + output;
      },
      viewPage(i){
          this.activeItem = i;
          this.pageSelected = true
      },
      viewMenu(){
          this.pageSelected = false
      },
      handleResize() {
          this.screenWidth = window.innerWidth;
      },
  },
    computed:{
    }
};
</script>
<style lang="less">
  @import "../assets/_theme-0";
  #GeneralInfo{
    .page-header {
      padding: 60px 0;
    }
    .page-title {
      text-align: left;
      &:first-letter{
        text-transform: uppercase;
      }
      h2 {
        text-align: left;
        font-size: 3.8rem;
        letter-spacing: 0.7rem;
        font-family: ff-cocon-web-pro, sans-serif;
        color: #fff;
      }
    }
    .return-link{
      font-size: 1.7rem;
      padding-bottom: 20px;
    }
      .page-results-title {
        margin: 0 0 24px 4px;
        font-family: "FilsonProLight", sans-serif;
        font-size: 19px;
        line-height: 1;
        text-transform: uppercase;
        color: #394961;
        opacity: 0.6;
      }
      .page-results-wrap {
        position: relative;
        &:before{
          position: absolute;
          content: '';
          top: 50%;
          width: 1px;
          height: 96%;
          left: 80px;
          transform: translateY(-50%);
          background-color: #014D71;
          z-index: 1;
        }
        .page-event:before{
          border: 1px solid #014D71;
        }
        .page-event, .page-content{
          border-color: #014D71;
          .page-title{
            color: #014D71;
            .title-box h3{
              color: #014D71;
            }
          }
        }
        .page-event {
          border-style: solid;
          border-width: 0 0 0 10px;
          border-radius:  0 10px 10px 0;
          box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.3);
          width: 100%;
          min-height: 75px;
          height: 75px;
          font-family: "FilsonProBold", sans-serif;
          display: flex;
          display: -ms-flexbox;
          -ms-flex-pack: start ;
          -webkit-box-align: start;
          justify-content: flex-start;
          align-items: center;
          flex-direction: row;
          cursor: pointer;
          flex-wrap: nowrap;
          position: relative;
          text-align: left;
          @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            //top: 25px;
            align-items: center;
            justify-content: flex-start;
          }
          &.active {
            box-shadow: none;
            background-color: #f6f6f6;
          }
          &:nth-last-child(1){
            margin-bottom: 0;
          }
          &:before{
            position: absolute;
            left: 78px;
            top: 50%;
            content: '';
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background-color: white;
            transform: translateY(-50%);
            z-index: 2;
          }
          .icon{
            width: 80px;
            flex-shrink: 0;
          }
          .page-title {
            font-size: 1.8rem;
            display: flex;
            justify-content: flex-start;
            &:first-letter{
              text-transform: uppercase;
            }
          }
          .marker {
            content: "";
            position: absolute;
            width: 12px;
            height: 12px;
            border: 1px solid #014D71;
            border-radius: 50%;
            background-color: white;
            transform: translateY(-50%);
            z-index: 1;
            right: 30px;
          }
        }
      }
    .page-head{
      width: 100%;
      height: 150px;
    }
    .page-content{
      text-align: center;
      .page-title{
        text-align: center;
        background-color: #fff;
        transform: translateY(-50%);
        padding: 5px 8px;
        .title-box{
          border: 1px solid #cdcdcd;
        }
      }
      .page-description{
        h4{
          transform: translateY(-50%);
          text-transform: capitalize;
          font-size: 2rem;
        }
      }
      .page-text{
        font-family: 'FilsonProBook', sans-serif;
        font-size: 1.6rem;
        text-align: left;
        color: #394961;
        h4{
          font-size: 2rem;
          text-align: center;
          margin-top: 30px;
        }
      }
    }
    .bg-white{
      min-height: calc(100vh - 380px);

    }
    .no-content{
      height: 100%;
      display: flex;
      min-height: calc(100vh - 380px);
      align-items: center;
      justify-content: center;
      text-align: center;
      img{
        max-width: 230px;
      }
      &>div {
        flex: 1;
      }
    }
    }
</style>
